<template>
  <div class="wrapper flex">
    <div class="container">
      <transition name="fade-up">
        <!-- <p v-if="formattedCard" :class="['card-container', isAce ? 'ace' : '']" @mouseover="showCategories = true" @mouseleave="showCategories = false">{{ formattedCard }}</p> -->
        <p v-if="formattedCard" :class="['card-container', isAce ? 'ace' : '']">{{ formattedCard }}</p>
      </transition>
      <div style="margin-top: 20px;">
        <transition name="fade-up-d1">
          <Dice v-if="localDice" :number="this.localDice.dice[0]" />
        </transition>
        <transition name="fade-up-d2">
          <Dice v-if="localDice" :number="this.localDice.dice[1]" />
        </transition>
      </div>
      <p :class="['fade-in day-count', showDay ? 'visible' : 'hidden']">Day {{ animatedCurrentDay }}</p>
      <div :class="['fade-in', showPrompts ? 'visible' : 'hidden']">
        <hr>
        <h3>{{ localSleepPrompt }}</h3>
        <h3>{{ getDreamPrompt(-1) }}</h3>
        <hr>
      </div>
      <div :class="['fade-in', showButton ? 'visible' : 'hidden']">
        <router-link to="/logs"><button>Wake up</button></router-link>
      </div>
    </div>
    <transition name="fade-up-d1">
      <pre v-show="showCategories" class="card-detail cat">{{ localCard.split(':')[1] }}: {{ latestPromptCategories.category }}</pre>
    </transition>
    <transition name="fade-up-d2">
      <pre v-show="showCategories" class="card-detail sub">{{ localCard.split(':')[0] }}: {{ latestPromptCategories.subcategory }}</pre>
    </transition>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';

import Dice from '@/components/Dice';

import gsap from 'gsap';

export default {
  name: 'sleep-transition',
  components: {
    Dice,
  },
  data() {
    return {
      localCurrentDay: 0,
      localCard: '',
      localDice: '',
      localSleepPrompt: '',
      localDayIncrease: 0,
      showPrompts: false,
      showButton: false,
      showDay: false,
      showCategories: false,
      interval: 1200,
    }
  },
  watch: {
    currentDay: function(newValue) {
      gsap.to(this.$data, { duration: this.interval * 2 / 1000, localCurrentDay: newValue });
    }
  },
  computed: {
    animatedCurrentDay() {
      return this.localCurrentDay.toFixed(0);
    },
    formattedCard() {
      return this.localCard.replace(':', '');
    },
    isAce() {
      return this.localCard.includes('A');
    },
    ...mapState({
      currentDay: state => state.calendar.currentDay,
      drawnCards: state => state.cards.drawnCards,
      excludedCards: state => state.cards.excludedCards,
    }),
    ...mapGetters([
      'weekLength',
      'moonLength',
      'seasonLength',
      'orbitLength',
      'getSleepPrompt',
      'getDreamPrompt',
      'latestPromptCategories',
    ]),
  },
  methods: {
    drawCardHandler() {
      let mode;
      if (this.drawnCards.length < 3) {
        mode = 'early';
      } else if (this.drawnCards.length === 3) {
        mode = 'ace';
      } else {
        mode = 'normal';
      }
      let card = this.drawCard(mode);
      if (card !== null) {
        this.localCard = card;
        this.recordCard(this.localCard);
        if (this.localCard.includes('A')) this.newReport();
        this.saveState();
      } else {
        console.log('deck finished!');
      }
    },
    diceRollHandler() {
      // roll dice
      this.localDice = this.roll2d6();
      this.recordDice(this.localDice);
      this.saveState();
      if (this.localDice.doubles) {
        switch (this.localDice.total) {
          case 2:
            // double 1: 2 weeks (18d)
            this.localDayIncrease = this.weekLength * 2;
            this.localSleepPrompt = `You sleep for two weeks (${this.weekLength * 2} days).`
            break;
          case 4:
            // double 2: 4 weeks (whole moon) (36d)
            this.localDayIncrease = this.moonLength;
            this.localSleepPrompt = `You sleep through a whole moon (${this.moonLength} days).`
            break;
          case 6:
            // double 3: 2 moons (72d)
            this.localDayIncrease = this.moonLength * 2;
            this.localSleepPrompt = `You sleep through two moons (${this.moonLength * 2} days).`
            break;
          case 8:
            // double 4: 3 moons (whole season) (108d)
            this.localDayIncrease = this.seasonLength;
            this.localSleepPrompt = `You sleep through an entire season (${this.seasonLength} days).`
            break;
          case 10:
            // double 5: 2 seasons (216d)
            this.localDayIncrease = this.seasonLength * 2;
            this.localSleepPrompt = `You sleep through two seasons (${this.seasonLength * 2} days).`
            break;
          case 12:
            // double 6: 3 seasons (324d)
            this.localDayIncrease = this.seasonLength * 3;
            this.localSleepPrompt = `You sleep through three seasons (${this.seasonLength * 3} days).`
            break;
        }
      } else {
        this.localDayIncrease = this.localDice.total;
        this.localSleepPrompt = `You sleep for ${this.localDice.total} days.`
      }
    },
    roll2d6() {
      let d1 = Math.ceil(Math.random() * 6);
      let d2 = Math.ceil(Math.random() * 6);

      let days;
      if (d1 === d2) {
        switch (d1 + d2) {
          case 2:
            // double 1: 2 weeks (18d)
            days = this.weekLength * 2;
            break;
          case 4:
            // double 2: 4 weeks (whole moon) (36d)
            days = this.moonLength;
            break;
          case 6:
            // double 3: 2 moons (72d)
            days = this.moonLength * 2;
            break;
          case 8:
            // double 4: 3 moons (whole season) (108d)
            days = this.seasonLength;
            break;
          case 10:
            // double 5: 2 seasons (216d)
            days = this.seasonLength * 2;
            break;
          case 12:
            // double 6: 3 seasons (324d)
            days = this.seasonLength * 3;
            break;
        }
      } else {
        days = d1 + d2;
      }

      return {
        dice: [d1, d2],
        total: d1 + d2,
        days: days,
        doubles: d1 === d2
      }
    },
    drawCard(mode) {
      // possible modes
      // normal: draw random card
      // ace: draw random ace
      // early: draw random card, no ace or face cards

      let done = false;
      let finalCard = '';
      if (this.drawnCards.length === 52 - this.excludedCards.length) {
        return null;
      } else {
        while (!done) {
          let suits = ['♠', '♦', '♣', '♥'];
          let suit = suits[Math.floor(Math.random() * suits.length)];
          let ranks, rank;
          switch (mode) {
            case 'normal':
              ranks = ['2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K', 'A'];
              rank = ranks[Math.floor(Math.random() * ranks.length)];
              break;
            case 'ace':
              rank = 'A';
              break;
            case 'early':
              ranks = ['2', '3', '4', '5', '6', '7', '8', '9', '10'];
              rank = ranks[Math.floor(Math.random() * ranks.length)];
              break;
          }
          let card = `${rank}:${suit}`;
          if (!this.drawnCards.includes(card) && !this.excludedCards.includes(card)) {
            finalCard = card;
            done = true;
          }
        }
        return finalCard;
      }
    },
    getDayIncrease() {
      return this.localDayIncrease;
    },
    ...mapMutations([
      'incrementDay',
      'saveState',
      'newReport',
      'recordCard',
      'recordDice',
    ]),
  },
  mounted() {
    this.localCurrentDay = this.currentDay;

    setTimeout(() => {
      this.drawCardHandler();
      this.diceRollHandler();
    }, this.interval);

    setTimeout(() => {
      this.showDay = true;
    }, this.interval * 2.5);

    setTimeout(() => {
      this.showPrompts = true;
    }, this.interval * 3.5);

    setTimeout(() => {
      this.showButton = true;
    }, this.interval * 4.5);

    setTimeout(() => {
      this.incrementDay(this.getDayIncrease());
      this.saveState();
    }, this.interval * 5);

    setTimeout(() => {
      this.showCategories = true;
    }, this.interval * 6.5);
  },
}
</script>

<style lang="css" scoped>
.flex {
  display: flex;
  height: calc(100% - 100px);
  width: calc(100% - 100px);
  position: absolute;
}

.container {
  margin: auto 0;
  text-align: center;
  width: 100%;
}

.card-container {
  border: 1px solid var(--primary-color);
  height: 56px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  margin: 0 auto 10px auto;
}

.card-container:hover {
  cursor: pointer;
}

.ace {
  background: var(--primary-color);
  color: var(--secondary-color);
}

.die {
  border: 1px solid var(--primary-color);
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  margin: 0 5px 5px;
  padding: 3px 9px;
}

.day-count {
  margin-bottom: 35px;
}

button {
  margin: 50px auto 0 auto;
}

.card-detail {
  position: absolute;
  bottom: -15px;
  font-size: 10px;
  text-transform: uppercase;
}

.cat {
  left: 0;
}

.sub {
  text-align: right;
  right: 0;
}
</style>
